import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NzButtonModule } from 'ant-reset-private/button';
import { NzAddOnModule, NzNoAnimationModule, NzOverlayModule } from 'ant-reset-private/core';
import { NzI18nModule } from 'ant-reset-private/i18n';
import { NzIconModule } from 'ant-reset-private/icon';
import { NzToolTipModule } from 'ant-reset-private/tooltip';

import { NzPopconfirmComponent } from './nz-popconfirm.component';
import { NzPopconfirmDirective } from './nz-popconfirm.directive';

@NgModule({
  declarations: [NzPopconfirmComponent, NzPopconfirmDirective],
  exports: [NzPopconfirmComponent, NzPopconfirmDirective],
  imports: [
    CommonModule,
    NzButtonModule,
    OverlayModule,
    NzI18nModule,
    NzIconModule,
    NzAddOnModule,
    NzOverlayModule,
    NzNoAnimationModule,
    NzToolTipModule
  ],
  entryComponents: [NzPopconfirmComponent]
})
export class NzPopconfirmModule {}
